import styled from 'react-emotion';

export const ErrorMessage = styled.div`
    padding: 5px;
`;




// WEBPACK FOOTER //
// ./src/styles/ErrorMessage.js